export interface ClosedRecall {
    repairDate: string;
    dealerTradeName: string;
    dealerAddress: string;
    localFsaDescLocal: string;
}